import { render, staticRenderFns } from "./SurveyAdmin.vue?vue&type=template&id=5268fb2e&scoped=true"
import script from "./SurveyAdmin.vue?vue&type=script&lang=js"
export * from "./SurveyAdmin.vue?vue&type=script&lang=js"
import style0 from "./SurveyAdmin.vue?vue&type=style&index=0&id=5268fb2e&prod&lang=scss"
import style1 from "./SurveyAdmin.vue?vue&type=style&index=1&id=5268fb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268fb2e",
  null
  
)

export default component.exports